import { Component, OnInit } from '@angular/core';
import { TranslationService } from '../../../core';
import { locales } from 'src/app/locales';
import { LocaleType } from 'src/app/core/interfaces/locale-type.interface';

@Component({
  selector: 'app-select-language',
  templateUrl: './select-language.component.html',
  styleUrls: ['./select-language.component.less'],
})
export class SelectLanguageComponent implements OnInit {
  locales: LocaleType[] = locales;
  currentLang: { value: string };

  constructor(private translationService: TranslationService) {
    this.setLanguage();
  }

  ngOnInit(): void {}

  setLanguage(culture = null) {
    const code = culture || this.translationService.getCurrentLang();
    const currentLang = this.locales.find((locale) => locale.code === code);
    this.currentLang = { value: currentLang.label };
  }

  changeLanguage(culture: string) {
    this.translationService.set(culture);
    this.setLanguage(culture);
  }
}
